(function () {
	const initProductAccordion = () => {
		$(document)
			.off("click.cpProductAccordion", ".about__accordion-toggle")
			.on("click.cpProductAccordion", ".about__accordion-toggle", function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active").attr("aria-expanded", "true");
				$(this).siblings(".about__accordion-description").stop().slideDown(300);
			} else {
				$(this).removeClass("active").attr("aria-expanded", "false");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
			});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();
